export default __webpack_public_path__ + "static/media/conexaonr_rgb_preferencial.253f08b1.png";